<template>
  <div class="c-detail">
    <template v-for="item in detail">
      <div
        v-if="item.name === 'content'"
        :key="item.name"
        class="c-detailRow c-detailRow-headingBlock"
      >
        <div class="c-detailRowHeading c-detailRow-headingBlock_heading">
          <div class="c-detailRowHeadingInner">{{ item.title }}</div>
        </div>
        <div class="c-detailRowContent">
          <div class="c-detailRowContentText nl2br">{{ displayContentText }}</div>
          <div
            class="c-readMoreContentText"
            v-if="contentTextNeedReadMore && !contentTextExpanded"
          >
            <a @click="contentTextExpanded = true">
              すべて見る
              <coconala-icon
                name="chevron-down"
                size="11px"
              />
            </a>
          </div>
        </div>
      </div>

      <div
        v-else-if="item.name === 'fileAttachment'"
        :key="item.name"
        class="c-detailRow"
      >
        <div class="c-detailRowHeading">
          <div class="c-detailRowHeadingInner">{{ item.title }}</div>
        </div>
        <div class="c-detailRowContent">
          <div
            class="c-detailRowContentEmpty"
            v-if="!item.contentJson.length"
          >ー</div>
          <div
            class="c-detailRowContentAttachedFiles"
            v-else
          >
            <a
              class="c-detailRowContentAttachedFile"
              v-for="(content, index) in item.contentJson"
              :key="index"
              :href="content.fileUrl"
              target="_blank"
              rel="nofollow ugc"
            >
              <coconala-icon
                name="clip"
                size="16px"
              />
              {{ truncatedFileName(content.fileName) }}
            </a>
          </div>
        </div>
      </div>

      <div
        v-else-if="item.name === 'referenceUrl'"
        :key="item.name"
        class="c-detailRow"
      >
        <div class="c-detailRowHeading">
          <div class="c-detailRowHeadingInner">{{ item.title }}</div>
        </div>
        <div class="c-detailRowContent">
          <div
            class="c-detailRowContentEmpty"
            v-if="!item.contentJson.length"
          >ー</div>
          <div
            class="c-detailRowContentReferenceUrls"
            v-else
          >
            <div
              class="c-detailRowContentReferenceUrl"
              v-for="(content, index) in item.contentJson"
              :key="index"
            >
              <a
                :href="content.text"
                class="c-detailRowContentReferenceUrl"
                target="_blank"
                rel="nofollow ugc"
              >
                {{ content.text }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="item.name === 'specialNote'"
        :key="item.name"
        class="c-detailRow"
      >
        <div class="c-detailRowHeading">
          <div class="c-detailRowHeadingInner">{{ item.title }}</div>
        </div>
        <div class="c-detailRowContent">
          <div
            class="c-detailRowContentEmpty"
            v-if="!item.contentJson.length"
          >ー</div>
          <div
            class="c-detailRowContentRemarks"
            v-else
          >
            <div
              class="c-detailRowContentRemark"
              v-for="(content, index) in item.contentJson"
              :key="index"
            >
              {{ content.label }}
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        :key="item.name"
        class="c-detailRow"
      >
        <div class="c-detailRowHeading">
          <div class="c-detailRowHeadingInner">{{ item.title }}</div>
        </div>
        <div class="c-detailRowContent">
          <div class="c-detailRowContentSkills">
            {{ implodeContentText(item.contentJson) }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
const CONTENT_TEXT_NOT_EXPANSION_LIMIT_COUNT = 400
const CONTENT_TEXT_NOT_EXPANSION_LIMIT_ROWS = 10

export default {
  name: 'ContentsDetail',
  props: {
    detail: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      contentTextExpanded: false
    }
  },
  computed: {
    contentText() {
      const content = this.detail.find(d => d.name === 'content').contentJson[0]
      return content ? content.text : ''
    },
    contentTextNeedReadMore() {
      if (!this.contentText) {
        return false
      }

      if (this.contentText.length > CONTENT_TEXT_NOT_EXPANSION_LIMIT_COUNT) {
        return true
      }

      if (this.contentText.split('\n').length > CONTENT_TEXT_NOT_EXPANSION_LIMIT_ROWS) {
        return true
      }

      return false
    },
    displayContentText() {
      if (!this.contentTextNeedReadMore || this.contentTextExpanded) {
        return this.contentText
      }

      const slicedContentText = this.contentText
        .split('\n')
        .slice(0, CONTENT_TEXT_NOT_EXPANSION_LIMIT_ROWS)
        .join('\n')

      return this.$util.truncate(slicedContentText, CONTENT_TEXT_NOT_EXPANSION_LIMIT_COUNT)
    }
  },
  methods: {
    implodeContentText(contents) {
      if (!contents.length) {
        return 'ー'
      }

      let text = ''
      contents.forEach((content, index) => {
        text += content.text ? content.text : content.label
        if (index < contents.length - 1) {
          text += '、'
        }
      })
      return text
    },
    truncatedFileName(fileName) {
      if (!fileName) {
        return ''
      }

      // ファイル名を 拡張子以外の部分を15文字でカット＋拡張子 にする
      const MAX_LENGTH = 15
      const splittedFileName = fileName.split('.')

      if (splittedFileName.length <= 1) {
        // 拡張子がない場合
        return this.$util.truncate(fileName, MAX_LENGTH)
      }

      const fileExtention = splittedFileName.pop()
      const fileNameWithoutExtention = splittedFileName.join('.')
      return this.$util.truncate(fileNameWithoutExtention, MAX_LENGTH) + '.' + fileExtention
    }
  }
}
</script>
<style lang="scss" scoped>
.c-detailRow {
  display: flex;

  & + & {
    margin-top: 24px;
  }

  &-headingBlock {
    flex-wrap: wrap;

    &_heading {
      margin-right: 0;
      margin-bottom: 8px;

      flex-basis: 100% !important;
    }
  }

  &-fileAttachment {
    margin-bottom: -8px;
  }
}

.c-detailRowHeading {
  flex: 0 0 120px;
  margin-right: 20px;
  line-height: 20px;
}

.c-detailRowHeadingInner {
  display: inline-block;
  padding: 0 12px;
  min-width: 120px;
  background: $color-gray-50;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
}

.c-detailRowContent {
  flex: 1 1 auto;
}

.c-detailRowContentText {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.c-detailRowContentAttachedFiles {
  display: flex;
  margin-bottom: -8px;

  flex-wrap: wrap;
}

.c-detailRowContentAttachedFile {
  @include link-effect;

  display: block;
  margin: 0 12px 8px 0;
  padding: 0 12px;
  border: 1px solid $color-blue-500;
  border-radius: 6px;
  color: $color-blue-500;
  white-space: nowrap;
  font-size: 12px;
  line-height: 34px;
}

.c-detailRowContentReferenceUrls {
  display: flex;
  flex-direction: column;
}

.c-detailRowContentReferenceUrl {
  overflow: hidden;
  color: $color-blue-500;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;

  & + & {
    margin-top: 4px;
  }

  a {
    @include link-effect;

    color: $color-blue-500;
  }
}

.c-detailRowContentSkills {
  line-height: 20px;
}

.c-detailRowContentSkill {
  display: inline-block;
}

.c-detailRowContentRemarks {
  line-height: 20px;
}

.c-detailRowContentRemark {
  display: inline-block;
  margin: 0 4px 4px 0;
  padding: 0 4px;
  border: 1px solid $color-gray-300;
  border-radius: 4px;
  color: $color-gray-700;
  font-size: 12px;
  line-height: 18px;
}

.c-detailRowContentEmpty {
  line-height: 20px;
}

.c-readMoreContentText {
  margin-bottom: 8px;
  color: $color-blue-500;
  font-size: 13px;
}

@media (max-width: breakpoint(Requests, M)) {
  .c-detail {
    padding: 12px 0 20px;
    border-bottom: 1px solid $color-gray-200;
  }

  .c-detailRow {
    margin-bottom: 12px;

    flex-wrap: wrap;

    &-headingBlock {
      &_heading {
        margin-bottom: 0;
      }
    }
  }

  .c-detailRowHeading {
    flex: 0 0 100%;
    margin-right: 0;
  }

  .c-detailRowHeadingInner {
    display: inline-block;
    padding: 0 12px;
    min-width: 120px;
    background: $color-white;
    text-align: left;
    font-weight: bold;
    font-size: 12px;
  }

  .c-detailRowContent {
    margin-top: 2px;
    padding: 0 12px;
    max-width: 100%;
  }

  .c-detailRowContentAttachedFile {
    display: block;
    flex: 0 0 100%;
    margin-right: 0;
  }

  .c-readMoreContentText {
    padding: 12px 0;
    border-bottom: 1px solid $color-gray-50;
    text-align: center;
    font-size: 12px;
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-detailRowContent {
    max-width: calc(100% - 140px);
  }
}
</style>
